(function () {
    'use strict';

    function entityProfilePercentageCompleteCalculatorService() {
        function calculateProfileCompletedPercentage(entity) {
            var totalPercentage = 100;
            if (!entity.Contact == null)
            {
                totalPercentage -= 30;
            }
            else
            {
                if (!(entity.Contact.TelephoneNumber || '').trim())
                {
                    totalPercentage -= 10;
                }
            }

            if (!entity.CompanyDetails)
            {
                totalPercentage -= 60;
            }
            else
            {
                if (!(entity.Contact.TelephoneNumber || '').trim())
                {
                    totalPercentage -= 10;
                }

                if (!(entity.CompanyDetails.City || '').trim())
                {
                    totalPercentage -= 10;
                }

                if (!(entity.CompanyDetails.ZipCode || '').trim())
                {
                    totalPercentage -= 10;
                }

                if (!(entity.CompanyDetails.Address || '').trim())
                {
                    totalPercentage -= 10;
                }

                if (!(entity.CompanyDetails.Url || '').trim())
                {
                    totalPercentage -= 10;
                }
            }

            if (entity.ViewModelType === "PlatformEntity" || entity.ViewModelType === "InsuranceBroker" ||
                entity.ViewModelType === "ProductProvider")
            {
                if (!(entity.Narrative || '').trim())
                totalPercentage -= 10;
            }

            return totalPercentage;
        }

        return {
            calculateProfileCompletedPercentage: calculateProfileCompletedPercentage
        }
    }

    entityProfilePercentageCompleteCalculatorService.$inject = [];

    angular.module('ecap.dashboards').service('entityProfilePercentageCompleteCalculatorService', entityProfilePercentageCompleteCalculatorService);
})();
